import {
  startToolOperation,
  type ToolAnalyticsContext,
  type ToolOperation,
} from '@saas-pages/shared/public/runtime'

const ANALYTICS_CONTEXT = {
  app: 'dateify',
  domain: 'dateify.ru',
  route: '/dobavit-dni-k-date',
  utility: 'add-subtract-date',
  processingMode: 'local',
} satisfies ToolAnalyticsContext

export function startWorkingDateOperation(): ToolOperation {
  return startToolOperation(ANALYTICS_CONTEXT)
}
